export default __webpack_public_path__ + "static/media/regen.0708dd59.webp";